import WrongTick from "../../assets/Icons/WrongTick.svg";
import RightTick from "../../assets/Icons/RightTick.svg";
import { useMediaQuery } from "@mui/material";
import WrongInput from "../../assets/Icons/WrongInput.svg";
import { AlertPopup } from "components/AlertPopup";
import {
  Box,
  FormControl,
  Input,
  IconButton,
  InputAdornment,
  MenuItem,
  MenuList,
  Paper,
  Stack,
  TextField,
  Typography,
  Tooltip,
} from "@mui/material";
import React, { FC, useRef, useState } from "react";
import { InputProps } from "../types";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import BootstrapTooltip from "../ToolTips/BootstrapTooltip";
import useMobilePasswordStyles from "./styles";
const MobilePassword: FC<any> = ({
  onChange,
  value,
  openMenu,
  conditions,
  width,
  border,
  err,
  customStyles,
  onKeyDown,
  customAdornment,
  margin = "normal",
  required = true,
  fullWidth = true,
  autoFocus = true,
  placeholder = "Password",
  type = "password",
  sx = { backgroundColor: "white", borderRadius: "10px" },
  id = "password",
  autoComplete = "current-password",
  className,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showErorrMessage, setShowErrMessage] = useState<boolean>(false);
  const isMobile = useMediaQuery("(max-width : 768px)");
  const classes = useMobilePasswordStyles();
  const handleClickShowPassword = () => {
    const ele = document.getElementById(`${id}`) as HTMLInputElement;
    ele.type = ele.type === "password" ? "text" : "password";
    setShowPassword(!showPassword);
  };
  const bgColor = "white";
  return (
    <Box>
      <Input
        placeholder={placeholder}
        onChange={onChange}
        type="password"
        disableUnderline={true}
        name={`password${id}`}
        id={id}
        value={value}
        fullWidth
        style={{
          background: bgColor,
          height: "40px",
          borderRadius: "10px",
          padding: "0 12px",
          fontFamily: "Lato",
          fontSize: "16px",
          border: err ? "1px solid red" : border,
          color: "black",
          fontWeight: 400,
        }}
        className={`${classes.default} ${className}`}
        endAdornment={
          <InputAdornment position="end">
            {err ? (
              <Box sx={{ marginTop: "5px" }}>
                {err &&
                  (isMobile ? null : (
                    <BootstrapTooltip title={err}>
                      <img src={WrongInput} />
                    </BootstrapTooltip>
                  ))}
              </Box>
            ) : null}

            <IconButton onClick={handleClickShowPassword}>
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
      {openMenu ? (
        <Stack
          direction="row"
          spacing={2}
          sx={{
            position: "absolute",
            borderRadius: "8px",
            zIndex: "2",
          }}
        >
          <Paper elevation={3} sx={{ padding: "8px 12px" }}>
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 600,
                fontSize: "10px",
                lineHeight: "12px",
                display: "flex",
                alignItems: "center",
                margin: "10px",
              }}
            >
              Password Requirement
            </Typography>
            <ul style={{ listStyle: "none", padding: "0px" }}>
              {[
                "8 characters",
                "1 capital letter",
                "1 special symbol",
                "1 number",
                "1 small letter",
                "Should not start with special symbol",
              ].map((item) => (
                <li>
                  <Box sx={{ display: "flex" }}>
                    <Box
                      sx={{ width: "8px", height: "5.5px", margin: "0px 10px" }}
                    >
                      <img
                        src={conditions?.includes(item) ? WrongTick : RightTick}
                      />
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Lato",
                          weight: 400,
                          fontSize: "12px",
                          lineHeight: "17.4px",
                          color: "#424242",
                        }}
                      >
                        {item}
                      </Typography>
                    </Box>
                  </Box>
                </li>
              ))}
            </ul>
          </Paper>
        </Stack>
      ) : null}

      {showErorrMessage ? (
        <Stack
          direction="row"
          spacing={2}
          sx={{
            position: "absolute",
            borderRadius: "8px",
          }}
        >
          <Paper elevation={3} sx={{ padding: "8px 12px" }}>
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 600,
                fontSize: "10px",
                lineHeight: "12px",
                display: "flex",
                alignItems: "center",
                margin: "10px",
              }}
            >
              {err}
            </Typography>
          </Paper>
        </Stack>
      ) : null}
    </Box>
  );
};

MobilePassword.defaultProps = {
  id: "password",
};

export default MobilePassword;
